import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.30252 3H2L9.47261 13.3324L2.47803 22H5.70973L11 15.4444L15.6975 21.9398H22L14.3103 11.3071L14.3239 11.3255L20.9449 3.1207H17.7132L12.7963 9.21366L8.30252 3ZM5.47888 4.80954H7.44094L18.5211 20.1301H16.5591L5.47888 4.80954Z"
    }, null, -1)
  ])))
}
export default { render: render }